import ActionsSection from '@/views/actions/ActionsSection.vue';
import Actions from '@/views/actions/Actions.vue';
import ActionCreate from '@/views/actions/ActionCreate.vue';
import Action from '@/views/actions/Action.vue';
import ActionDetails from '@/views/actions/tabs/ActionDetails.vue';
import ActionDelete from '@/views/actions/tabs/ActionDelete.vue';
import ActionEdit from '@/views/actions/tabs/ActionEdit.vue';

export default [
  {
    path: '/actions',
    component: ActionsSection,
    meta: {
      breadcrumb: {
        linkName: 'actions.index',
        linkText: 'Actions',
      },
    },
    children: [
      {
        path: '',
        component: Actions,
        name: 'actions.index',
      },
      {
        path: 'create',
        component: ActionCreate,
        name: 'actions.index.create',
      },
      {
        path: ':id',
        component: Action,
        meta: {
          breadcrumb: {
            linkName: 'actions.index.detail',
            linkText: 'Action Summary',
          },
        },
        children: [
          {
            path: '',
            name: 'actions.index.detail',
            component: ActionDetails,
          },
          {
            path: 'delete',
            name: 'actions.index.detail.delete',
            component: ActionDelete,
          },
          {
            path: 'edit',
            name: 'actions.index.detail.edit',
            component: ActionEdit,
          },
        ],
      },
    ],
  },
];
